import React from 'react';
import { adminHeaderBar } from './adminStyles';

const SystemAdminHeader = () => {
  return (
    <header className={`${adminHeaderBar} hidden md:flex`}>
      <h2 className="text-lg sm:text-xl font-medium text-stone-800">システム管理者画面</h2>
      <span className="min-w-0 truncate text-sm text-stone-600">admin 様</span>
    </header>
  );
};

export default SystemAdminHeader;
